import { Component } from '@angular/core';
import { AutoCompleteComponent } from '@components/dynamic-form/auto-complete/auto-complete.component';

@Component({
  selector: 'app-auto-complete-contact-source',
  templateUrl: '../../auto-complete.component.html',
  styleUrls: ['../../auto-complete.component.scss'],
})
export class AutoCompleteContactSourceComponent extends AutoCompleteComponent {
  displayFn(selectedoption: any): string {
    return selectedoption && selectedoption.descrizione ? selectedoption.descrizione : '';
  }

  protected getValue(obj: any) {
    return obj?.descrizione ?? '';
  }
}
